// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#a7ebf4","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#1c5589","menuHover":"rgba(13,167,201,0.34902)","subMenuBg":"#0e4577","subMenuHover":"rgba(13,167,201,0.35)","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 171